import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import ApplicationLogo from "./ApplicationLogo";
import ContextBar from "../contextbar/ContextBar";
import Aux from "../utility/Aux";
import { UserType } from "../../api/Authentication";

/**
 * Includes the top bar-specific stylesheet
 */
import "./TopBar.css";

/**
 * TopBar: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Top bar component, containing the application logo,
 * context bar (if logged in) and the info tray.
 *
 * @param {*} props
 */
const TopBar = props => (
  <div className="ax-top-bar">
    <ApplicationLogo userType={props.userType} />
    {props.isAuthenticated && (
      <Aux>
        <ContextBar {...props} />
      </Aux>
    )}
  </div>
);

const mapStateToProps = state => ({
  isAuthenticated: !!state.user.uid,
  userType: UserType.Demo
});

TopBar.propTypes = {
  /**
   * isAuthenticated: Boolean
   * True if the user is currently logged in
   */
  isAuthenticated: PropTypes.bool.isRequired,
  /**
   * userType: UserType
   * Type of the currently logged in user
   */
  userType: PropTypes.string.isRequired
};

export default withRouter(connect(mapStateToProps)(TopBar));



// WEBPACK FOOTER //
// ./src/components/topbar/TopBar.js